import { render, staticRenderFns } from "./UpdateArticulado.vue?vue&type=template&id=d96a914e"
import script from "./UpdateArticulado.vue?vue&type=script&lang=js"
export * from "./UpdateArticulado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports